import {
  COMPONENT_VALUE_TYPES as types, WATERFALL_GALLERY_IMAGE_SIZES, PERCENTAGES, BACKGROUND_IMAGE_POSITION
} from 'shared/constants';

const propsSchema = [
  {
    key: 'gallery_options',
    label: 'Options',
    type: types.OBJECT,
    children: [
      {
        key: 'mobile_carousel',
        label: 'Mobile Carousel',
        type: types.BOOLEAN
      },
      {
        key: 'gallery_button',
        label: 'Gallery Button',
        type: types.BOOLEAN
      },
      {
        key: 'top_offset',
        label: 'Top Offset',
        type: types.BOOLEAN,
      },
      {
        key: 'social_media_icons',
        label: 'Show Social Media Icons',
        type: types.BOOLEAN,
      },
      {
        key: 'full_gallery_link',
        label: 'Full Gallery Link',
        type: types.TEXT
      },
      {
        key: 'gallery_button_label',
        label: 'Gallery Button Label',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'images',
    label: 'Asset Gallery',
    type: types.WATERFALL_GALLERY,
    children: [
      {
        key: 'id',
        label: 'ID'
      },
      {
        key: 'members',
        label: 'Members'
      },
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT,
      },
      {
        key: 'size',
        label: 'Size',
        type: types.ENUM,
        options: WATERFALL_GALLERY_IMAGE_SIZES
      },
      {
        key: 'socialUrl',
        label: 'Social URL',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'bg_img',
    label: 'Background Image',
    type: types.OBJECT,
    children: [
      {
        key: 'url',
        label: 'Url',
        type: types.TEXT
      },
      {
        key: 'dark_overlay',
        label: 'Dark Overlay',
        type: types.ENUM,
        options: PERCENTAGES
      },
      {
        key: 'position',
        label: 'Background Position',
        type: types.ENUM,
        options: BACKGROUND_IMAGE_POSITION
      },
      {
        key: 'fixed_bg',
        label: 'Fixed Background',
        type: types.BOOLEAN
      },
      {
        key: 'disable_img',
        label: 'Solid Background Color',
        type: types.BOOLEAN
      },
      {
        key: 'background_color',
        label: 'Background Color',
        type: types.COLOR_PICKER
      }
    ]
  },
  {
    key: 'intro_text',
    label: 'Intro Text',
    type: types.TEXT
  },
  {
    type: types.OBJECT,
    key: 'social_share',
    label: 'Social Share',
    children: [
      {
        type: types.TEXT,
        key: 'qr_code_url',
        label: 'QR Code URL'
      },
      {
        type: types.ARRAY,
        key: 'social_media_icons',
        label: 'Social Media Icons',
        children: [
          {
            type: types.TEXT,
            key: 'url',
            label: 'URL',
          },
          {
            type: types.TEXT,
            key: 'icon',
            label: 'Icon'
          }
        ]
      }
    ]
  }
];

const defaultProps = {
  gallery_options: {
    mobile_carousel: true,
    gallery_button: true,
    top_offset: true,
    social_media_icons: false,
    full_gallery_link: '/ff-91/gallery',
    gallery_button_label: 'Full Gallery'
  },
  images: [
    {
      id: 0,
      members: [0, 4],
      url: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-01.jpg',
      size: 'VERTICAL_MEDIUM'
    },
    {
      id: 1,
      members: [1, 2],
      url: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-02.jpg',
      size: 'HORIZONTAL_MEDIUM'
    },
    {
      id: 3,
      members: [3],
      url: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-03.jpg',
      size: 'SMALL'
    },
    {
      id: 5,
      members: [5],
      url: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-04.jpg',
      size: 'SMALL'
    },
    {
      id: 6,
      members: [6, 7],
      url: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-05.jpg',
      size: 'HORIZONTAL_MEDIUM'
    }
  ],
  bg_img: {
    url: 'https://genesis-cdn.ff.com/product/02_gallery/faraday-future-ff-91-image-gallery-06.jpg',
    dark_overlay: 0,
    position: 'CENTER CENTER',
    fixed_bg: true,
    disable_img: true,
    background_color: '#000'
  },
  intro_text: '',
  social_share: {
    qr_code_url: 'https://www.ff.com/',
    social_media_icons: [
      { url: 'https://www.linkedin.com/shareArticle?mini=true&url={page url}&title={article title}&summary={short description}', icon: 'ff-icon-social-linkedin' },
      { url: 'https://twitter.com/share?url={URL}&text={article title} @FaradayFuture', icon: 'ff-icon-social-twitter' },
      { url: 'https://www.facebook.com/sharer/sharer.php?u={URL}', icon: 'ff-icon-social-facebook' },
      { url: 'mailto:?subject={article title}&body={URL}', icon: 'ff-icon-mail' },
      { url: 'http://service.weibo.com/share/share.php?url={URL}&title={article title} @FaradayFuture&appkey=1343713053&pic=&searchPic=false', icon: 'ff-icon-social-weibo' },
      { url: '{URL}', icon: 'ff-icon-social-wechat' }
    ]
  }
};

export default {
  title: 'Waterfall Gallery',
  id: 'WaterfallGallery',
  widgetImage: '/widgetImages/Waterfall+gallery.png',
  basic: true,
  propsSchema,
  defaultProps
};
